module.exports = __webpack_public_path__ + "img/Z86_08.2fcfc66a.jpg";